import { apiClient } from './apiClient';
import { ArticleData } from '../types/Article';

export const articleService = {
  async findAll(): Promise<any[]> {
    try {
      console.log('Buscando todos os artigos...');
      const response = await apiClient.fetch('/articles');
      const data = await response.json();
      console.log('Artigos recebidos:', data);
      return data.map((article: any) => ({
        ...article,
        createdAt: new Date(article.createdAt),
        updatedAt: new Date(article.updatedAt)
      }));
    } catch (error) {
      console.error('Erro na requisição:', error);
      throw error;
    }
  },

  async findBySearch(searchTerm: string): Promise<any[]> {
    try {
      console.log('Buscando artigos com termo:', searchTerm);
      const response = await apiClient.fetch(
        `/articles/search?term=${encodeURIComponent(searchTerm)}`
      );
      const data = await response.json();
      console.log('Resultados da busca:', data);
      return data.map((article: any) => ({
        ...article,
        createdAt: new Date(article.createdAt),
        updatedAt: new Date(article.updatedAt)
      }));
    } catch (error) {
      console.error('Erro na busca:', error);
      throw error;
    }
  },

  async create(articleData: any): Promise<any> {
    try {
      console.log('Criando novo artigo:', articleData);
      
      // Primeiro confirmar o upload dos arquivos que estão na sessão
      console.log('Confirmando upload dos arquivos com UUID:', articleData.fileUuid);
      const uploadResponse = await apiClient.fetch('/articles/processing/confirm', {
        method: 'POST',
        body: JSON.stringify({ fileUuid: articleData.fileUuid }),
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!uploadResponse.ok) {
        const errorData = await uploadResponse.json().catch(() => null);
        throw new Error(errorData?.message || 'Erro ao confirmar upload');
      }

      const uploadData = await uploadResponse.json();
      console.log('Upload confirmado:', uploadData);

      // Agora criar o artigo com os dados completos
      const response = await apiClient.fetch('/articles', {
        method: 'POST',
        body: JSON.stringify({
          ...articleData,
          pdfUrl: uploadData.pdfUrl,
          coverUrl: uploadData.coverUrl
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        console.error('Erro na resposta do servidor:', {
          status: response.status,
          statusText: response.statusText,
          error: errorData,
          url: response.url
        });
        throw new Error(errorData?.message || 'Erro ao criar artigo');
      }

      const data = await response.json();
      console.log('Artigo criado com sucesso:', data);
      return {
        ...data,
        createdAt: new Date(data.createdAt),
        updatedAt: new Date(data.updatedAt)
      };
    } catch (error) {
      console.error('Erro ao criar artigo:', error);
      throw error;
    }
  },

  async delete(id: number): Promise<void> {
    try {
      console.log('Iniciando exclusão do artigo:', id);
      
      const response = await apiClient.fetch(`/articles/${id}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao excluir artigo');
      }

      console.log('Artigo excluído com sucesso:', id);
    } catch (error) {
      console.error('Erro ao excluir artigo:', error);
      throw error;
    }
  },

  async update(id: number, articleData: any) {
    try {
      console.log('Iniciando atualização do artigo:', { id, data: articleData });
      
      const token = localStorage.getItem('auth_token');
      if (!token) {
        throw new Error('Usuário não autenticado');
      }

      const response = await apiClient.fetch(`/articles/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(articleData),
        credentials: 'include'
      });

      console.log('Artigo atualizado com sucesso:', response);
      return response;
    } catch (error) {
      console.error('Erro ao atualizar artigo:', error);
      throw error;
    }
  },

  async checkDoi(doi: string) {
    try {
      console.log('[ArticleService] Verificando DOI:', doi);
      
      const encodedDoi = encodeURIComponent(doi);
      const response = await apiClient.fetch(`/articles/check-doi/${encodedDoi}`, {
        credentials: 'include'
      });
      
      console.log('[ArticleService] Resposta:', response);
      
      return {
        exists: response.exists,
        article: response.article
      };
    } catch (error) {
      console.error('Erro ao verificar DOI:', error);
      throw error;
    }
  },

  async saveProcessedArticle(fileUuid: string, data: ArticleData) {
    try {
      console.log('📤 Iniciando salvamento do artigo:', { fileUuid, data });
      
      const response = await apiClient.fetch(`/article-processing/save/${fileUuid}`, {
        method: 'POST',
        body: JSON.stringify(data)
      });

      return response;
    } catch (error) {
      console.error('❌ Erro ao salvar artigo:', error);
      throw error;
    }
  }
}; 